import { render, staticRenderFns } from "./RemovePatientsModal.vue?vue&type=template&id=7d3370ba"
import script from "./RemovePatientsModal.vue?vue&type=script&lang=js"
export * from "./RemovePatientsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports